import axios from "axios"

const endpoint = "/api/credit-cards" // Passe dies an deinen Router-Pfad an

function getHeaders() {
  return { headers: { Authorization: localStorage.getItem("token") } }
}

export default {
  creditCardBills: {
    sign(id) {
      return axios.post(`${endpoint}/${id}/sign`, {}, getHeaders()).then((res) => res.data)
    },
    signBulk(ids) {
      return axios.post(`${endpoint}/sign-bulk`, { ids }, getHeaders()).then((res) => res.data)
    },
    addComment(id, text) {
      return axios.post(`${endpoint}/${id}/comments`, { text }, getHeaders()).then((res) => res.data)
    },
    deleteComment(id, commentId) {
      return axios.delete(`${endpoint}/${id}/comments/${commentId}`, getHeaders()).then((res) => res.data)
    },
    downloadBulk(ids, month, year) {
      return axios.post(`${endpoint}/download-bulk`, { ids, month, year }, { ...getHeaders(), responseType: "blob" }).then((response) => {
        const blob = new Blob([response.data], { type: "application/zip" })
        const link = document.createElement("a")
        link.href = URL.createObjectURL(blob)
        link.download = `CC_Belege_${month || ""}_${year || ""}.zip`
        link.click()
        URL.revokeObjectURL(link.href)
      })
    },
    fetchUploaders() {
      return axios.get(`${endpoint}/uploaders`, getHeaders()).then((res) => res.data)
    },
    fetchStats(params) {
      return axios
        .get(`${endpoint}/stats`, {
          params: params,
          ...getHeaders(),
        })
        .then((res) => res.data)
    },
    update(id, data) {
      // data ist hier ein normales JS Objekt, kein FormData, da wir das Bild meist nicht ändern beim Editieren
      return axios.put(`${endpoint}/${id}`, data, getHeaders()).then((res) => res.data)
    },
    delete(id) {
      return axios.delete(`${endpoint}/${id}`, getHeaders()).then((res) => res.data)
    },
    fetchAll(params) {
      // params: { search, studioId, uploaderId, dateFrom, dateTo, minAmount, maxAmount ... }
      // Convert params object to query string via axios params serializer or just pass object
      return axios
        .get(endpoint, {
          params: params,
          ...getHeaders(),
        })
        .then((res) => res.data)
    },
    async analyzeStream(formData, onProgress) {
      const token = localStorage.getItem("token")

      const response = await fetch(`${endpoint}/analyze`, {
        method: "POST",
        headers: {
          Authorization: token,
          "x-no-compression": "true", // Wichtig für Streaming!
        },
        body: formData,
      })

      if (!response.ok) throw new Error("Netzwerkfehler beim Starten der Analyse")

      const reader = response.body.getReader()
      const decoder = new TextDecoder()

      // WICHTIG: Buffer muss AUSSERHALB des Loops definiert sein
      let buffer = ""

      while (true) {
        const { done, value } = await reader.read()
        if (done) break

        // 1. Neuen Chunk zum bestehenden Buffer hinzufügen
        buffer += decoder.decode(value, { stream: true })

        // 2. Den Buffer an den SSE-Trennzeichen (\n\n) aufsplitten
        const lines = buffer.split("\n\n")

        // 3. TRICK: Das letzte Element ist oft unvollständig (weil der Stream mitten im Satz abriss).
        // Wir entfernen es aus der Liste und packen es zurück in den Buffer für die nächste Runde.
        buffer = lines.pop()

        // 4. Nur die VOLLSTÄNDIGEN Zeilen verarbeiten
        for (const line of lines) {
          const trimmedLine = line.trim()
          if (trimmedLine.startsWith("data: ")) {
            try {
              const jsonStr = trimmedLine.replace("data: ", "")
              const payload = JSON.parse(jsonStr)

              if (payload.type === "token") {
                if (onProgress) onProgress(payload.content)
              } else if (payload.type === "result") {
                return payload.data
              } else if (payload.type === "error") {
                throw new Error(payload.message)
              }
            } catch (e) {
              console.warn("JSON Parse Error (übersprungen):", e)
            }
          }
        }
      }
    },
    // NEW: Analyze Receipt
    analyze(formData) {
      return axios.post(`${endpoint}/analyze`, formData, getHeaders()).then((res) => res.data)
    },

    upload(formData) {
      return axios.post(`${endpoint}/upload`, formData, getHeaders()).then((res) => res.data)
    },

    getFileUrl(id) {
      // Gibt die URL zurück, die das Frontend für <img> Tags nutzen kann
      // (Achtung: Token muss ggf. als Query Param übergeben werden oder via axios fetchBlob gehandhabt werden,
      // da <img> keine Header sendet.
      // Lösung hier: Wir laden das Bild per JS und setzen Blob URL)
      return `${endpoint}/file/${id}`
    },

    // Helper um Blob für Image-Preview zu laden (da Auth Header nötig)
    async fetchImageBlob(id) {
      const response = await axios.get(`${endpoint}/file/${id}`, {
        ...getHeaders(),
        responseType: "blob",
      })
      return URL.createObjectURL(response.data)
    },

    async fetchThumbnailBlob(id) {
      const response = await axios.get(`${endpoint}/thumbnail/${id}`, {
        ...getHeaders(),
        responseType: "blob",
      })
      return URL.createObjectURL(response.data)
    },

    async downloadPdf(params, year) {
      if (!params || typeof params !== "object") params = { month: params, year }
      let response
      try {
        response = await axios.get(`${endpoint}/export/pdf`, { params, ...getHeaders(), responseType: "blob" })
      } catch (error) {
        let message = "PDF konnte nicht heruntergeladen werden."
        const data = error.response && error.response.data
        if (data instanceof Blob) {
          try {
            const detail = JSON.parse(await data.text())
            if (detail.msg) message = detail.msg
          } catch (_) {
            // Keep the readable fallback for non-JSON error responses.
          }
        } else if (data && data.msg) {
          message = data.msg
        }
        throw new Error(message)
      }
      const blob = new Blob([response.data], { type: "application/pdf" })
      const url = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.download = `CC_Auszug_${params.month}_${params.year}.pdf`
      document.body.appendChild(link)
      link.click()
      link.remove()
      setTimeout(() => URL.revokeObjectURL(url), 1000)
    },
  },
}
